import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { APPCONFIG } from "../config";

@Injectable()
export class DevedorService extends BaseService {
    constructor(private http: Http) {
        super();
        this._api = '/api/devedores/';                       
    }

    getDevedorLogado() {        
        return this.get(this._api + 'Logado')
            .map((response: Response) => response);
    }

    getDevedorPorTelefone(numerocelular: any) {        
        return this.get(`${this._api}logintelefones/${numerocelular}`);
    }

    getDevedorPorClienteId(clienteId: any) {        
        return this.get(`${this._api}loginClientes/${clienteId}`);
    }

    getAcordo() {
        return (this.get(`${this._api}acordos`));
    }       

    getDividas(contratoid: any) {
        return (this.get(`${this._api}dividas/${contratoid}`));
    }

    getVerificarAcordoExistente(contratoid: any) {
        return (this.get(`${this._api}VerificarAcordoExistente/${contratoid}`));
    }

    getlistaAudios(devedorid: any) {
        return (this.get(`${this._api}listaAudios/${devedorid}`));
    }

    getAudio(audioId: any) {
        return (this.get(`${this._api}audio/${audioId}`));
    }

    getDividasPortal() {
        return (this.get(`${this._api}acordoPortal`));
    }

    getClienteTelefonesPorClienteId(clienteId: any) {        
        return this.get(`${this._api}clientetelefones/${clienteId}`);
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/devedor.service.ts